import moment from "moment";
import pgwyClient from "@/api/pgwyClient";

const Certificates = {
  state: {
    certificates: null,
    searchParameters: {
      searchLimit: 10,
      searchOffset: 1
    },
  },
  mutations: {
    setCertificates(state, certificates) {
      state.certificates = certificates;
      state.certificates.certificates.forEach((cert) => {

        const starts = moment(cert.validfrom);
        const ends = moment(cert.validto);
        cert.totalLifespan = moment.preciseDiff(starts, ends, true);

        const now = new Date().getTime();
        const from = new Date(cert.validfrom).getTime();
        const to = new Date(cert.validto).getTime();

        if (now < from) {
          cert.lifespan = 100;
        } else if (now > to) {
          cert.lifespan = 0;
        } else {
          cert.lifespan = Math.floor(100 * (to-now) / (to-from));
        }

        cert.timeToExpire = new Date(cert.validto);

        cert.class = "";
        cert.validfrom = changeDateFormat(cert.validfrom);
        cert.validto = changeDateFormat(cert.validto);
        if (cert.revocationtime) {
          cert.revocationtime = changeDateFormat(cert.revocationtime);
        }
      });

      function changeDateFormat(date) {
        return moment(date).format("YYYY/MM/DD hh:mm [CET]");
      }
    },
    setCertificateSearchParameters(state, searchParameters) {
      const mandatory = {
        searchOffset: state.searchParameters.searchOffset,
        searchLimit: state.searchParameters.searchLimit,
      };
      if (state.searchParameters.orderBy !== undefined) {
        mandatory.orderBy = state.searchParameters.orderBy;
      }
      if (state.searchParameters.orderDescending !== undefined) {
        mandatory.orderDescending = state.searchParameters.orderDescending;
      }
      state.searchParameters = { ...mandatory, ...searchParameters };
    }
  },
  actions: {
    async updateCertificateSearchParams({ dispatch, commit, state }, searchParameters) {
      commit("setCertificateSearchParameters", searchParameters);
      return await dispatch("updateCertificates");
    },
    async updateCertificates({ commit, state }) {
      const params = {
        ...state.searchParameters,
        searchOffset:
            (state.searchParameters.searchOffset - 1) *
            state.searchParameters.searchLimit,
      };
      const res = await pgwyClient.getCertificates(params)
      commit("setCertificates", res.data);
    }
  },

  getters: {
    getCertificates(state) {
      return state.certificates;
    },
    getCertificateSearchParams(state) {
      return state.searchParameters;
    },
  },
};

export default Certificates;
